import React, { useEffect, useState } from "react";
import Breadcrumb from "../../components/breadcrumbcomponents/Breadcrumb";
import FirstImage from "../../components/productcomponents/FirstImage";
import BlogList from "../../components/blogcomponents/BlogAllBlogsSec";
import { BlogZeroHero } from "../../components/blogcomponents/BlogZeroToHeroSec";
import Blogslider from "../../components/blogcomponents/BlogSlider";
import { Blogretailreview } from "../../components/blogcomponents/BlogRetailReview";
import { ManufacturerCard } from "../../components/homecomponents/ManuFacturerCard";
import { BlogOwnStorySec } from "../../components/blogcomponents/BlogOwnStorySec";
import axios from "axios";
import {
  ALL_PAGE_SEO_API,
  BLOG_API,
  BLOG_CATEGORY_DETAILS_API,
  SCRIPT_URL,
} from "../../config/config";
import Loader from "../../components/loaderspinnercomponents/Loader";
import { Helmet } from "react-helmet-async";
import { useParams } from "react-router-dom";

export const Blog = () => {
  const [BlogBenner, setBlogBenner] = useState([]);
  const [Bloglist, setBloglist] = useState([]);
  const [BlogSlider, setBlogSlider] = useState([]);
  const [Blogreview, setBlogreview] = useState([]);
  const [counter, setCounter] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [loading, setLoading] = useState(false);
  const [maxrecord, setmaxrecord] = useState();
  const [seoData, setSeoData] = useState([]);
  const [cateMetaData, setCateMetaData] = useState();
  const { categoryname } = useParams();

  const seofetchData = async () => {
    try {
      const response = await axios.get(ALL_PAGE_SEO_API);
      if (response) {
        // setSeoData(response.data.DATA[7].meta);
        setSeoData(response?.data?.DATA.find(item => item.pagename === "blogpage")?.meta || {});
      } else {
        console.error("Unexpected API response structure:", response.data);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const fetchBlogData = async (page) => {
    setLoading(true);
    try {
      const response = await axios.post(BLOG_API, {
        page,
        maxrecord,
      });
      if (response.data.DATA) {
        setBlogBenner(response.data.DATA[0].data[0].image);
        setBloglist(response.data.DATA[1].data.data);
        setTotalPages(response.data.DATA[1].data.last_page);
        setCurrentPage(response.data.DATA[1].data.current_page);
        setBlogSlider(response.data.DATA[2].data);
        setBlogreview(response.data.DATA[4].data);
        setCounter(response.data.Total_Count);
      } else {
        console.error("Unexpected API response structure:", response.data);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setTimeout(() => {
        setLoading(false);
      }, 1000);
    }
  };

  // Fetch blogs by selected category
  const fetchBlogsByCategory = async (categorySlug, page = 1) => {
    try {
      const response = await axios.post(`${BLOG_CATEGORY_DETAILS_API}`, {
        slug: categorySlug,
      });
      if (response?.data?.blogcategory) {
        setCateMetaData(response.data.blogcategory);
      }
    } catch (error) {
      console.error("Error fetching category blogs:", error);
    }
  };

  const jsonLdData = {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "BreadcrumbList",
        "@id": `${SCRIPT_URL}/blog/`,
        itemListElement: [
          {
            "@type": "ListItem",
            "@id": `${SCRIPT_URL}`,
            position: 1,
            name: "Home",
            item: `${SCRIPT_URL}`,
            nextItem: `${SCRIPT_URL}/blog/`,
          },
          {
            "@type": "ListItem",
            "@id": `${SCRIPT_URL}/blog/`,
            position: 2,
            name: "blog",
            previousItem: `${SCRIPT_URL}`,
          },
        ],
      },
      {
        "@type": "Organization",
        "@id": `${SCRIPT_URL}`,
        name: "Keasria Textile Company",
        description: "Fashion is King",
        url: `${SCRIPT_URL}`,
        logo: {
          "@type": "ImageObject",
          url: `${SCRIPT_URL}/wp-content/uploads/2022/01/cropped-ktc-logo-1.webp`,
          "@id": `${SCRIPT_URL}/blog/`,
          width: 512,
          height: 512,
          caption: "cropped-ktc-logo-1.webp",
        },
        image: { "@id": `${SCRIPT_URL}/blog/` },
      },
      {
        "@type": "WebPage",
        "@id": `${SCRIPT_URL}/blog/`,
        url: `${SCRIPT_URL}/blog/`,
        name: categoryname
          ? cateMetaData?.meta_title ||
          "Blog Category | Kesaria Textile Company ~ Top Textile Company In Surat"
          : seoData?.meta_title ||
          "Blog Page | Kesaria Textile Company ~ Top Textile Company In Surat",
        description: categoryname
          ? cateMetaData?.meta_description ||
          "Kesaria textiles is one of the leading manufacturer, exporter, wholesalers and dealers of high quality & best rated textile company in Surat."
          : seoData?.meta_description ||
          "Kesaria textiles is one of the leading manufacturer, exporter, wholesalers and dealers of high quality & best rated textile company in Surat.",
        inLanguage: "en-US",
        isPartOf: { "@id": `${SCRIPT_URL}` },
        breadcrumb: { "@id": `${SCRIPT_URL}/blog/` },
        datePublished: "2016-07-18T08:59:30+05:30",
        dateModified: "2024-05-22T13:51:32+05:30",
      },
      {
        "@type": "WebSite",
        "@id": `${SCRIPT_URL}`,
        url: `${SCRIPT_URL}`,
        name: "Kesaria Textile Company",
        description: "Fashion is King",
        inLanguage: "en-US",
        publisher: { "@id": `${SCRIPT_URL}` },
      },
    ],
  };

  useEffect(() => {
    localStorage.removeItem("city_name");
    localStorage.removeItem("country_name");
  }, []);


  useEffect(() => {
    fetchBlogData(currentPage, maxrecord);
    seofetchData();
    fetchBlogsByCategory();
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, [currentPage, maxrecord]);

  const handlePageChange = (event, value) => {
    setCurrentPage(value);
    fetchBlogData(value, maxrecord);
  };

  return (
    <>
      {loading ? (
        <div className="d-flex justify-content-center align-items-center vh-100">
          <Loader />
        </div>
      ) : (
        <div className="blog-page pb-lg-5">
          <FirstImage image={BlogBenner} />
          <Breadcrumb
            breadcrumbTitle={
              categoryname ? categoryname.replace(/-/g, " ") : "Blogs"
            }
            breadcrumbNav={[
              {
                navText: "Home",
                path: "/",
              },
              ...(categoryname
                ? [
                  {
                    navText: "Blogs",
                    path: "/blog",
                  },
                ]
                : []),
            ]}
          />

          <Helmet>
            <meta charSet="utf-8" />
            <title>
              {categoryname
                ? cateMetaData?.meta_title ||
                "Blog Category |Kesaria Textile Company ~ Top Textile Company In Surat"
                : seoData?.meta_title ||
                "Blog Page | Kesaria Textile Company ~ Top Textile Company In Surat"}
            </title>
            <link
              rel="canonical"
              href={`${window.location.hostname == "localhost" ? "http" : "https"
                }://${window.location.host}/blog/`}
            />
            <link rel="publisher" href={`${SCRIPT_URL}`}></link>
            <meta
              name="description"
              content={
                categoryname
                  ? cateMetaData?.meta_description ||
                  "Kesaria textiles is one of the leading manufacturer, exporter, wholesalers and dealers of high quality & best rated textile company in Surat"
                  : seoData?.meta_description ||
                  "Kesaria textiles is one of the leading manufacturer, exporter, wholesalers and dealers of high quality & best rated textile company in Surat"
              }
            />
            <meta
              content={
                categoryname
                  ? cateMetaData?.meta_keyword ||
                  "Leading Saree Manufacturers In Surat."
                  : seoData?.meta_keyword ||
                  "Leading Saree Manufacturers In Surat."
              }
            />
            <meta property="og:locale" content="en_US" />
            <meta
              property="og:site_name"
              content="Kesaria Textile Company | Fashion is King"
            />
            <meta
              property="og:title"
              content={
                categoryname
                  ? cateMetaData?.meta_title ||
                  "Blog Category | Kesaria Textile Company ~ Top Textile Company In Surat"
                  : seoData?.meta_title ||
                  "Blog Page | Kesaria Textile Company ~ Top Textile Company In Surat"
              }
            />
            <meta property="og:type" content="article" />
            <meta
              name="description"
              property="og:description"
              content={
                categoryname
                  ? cateMetaData?.meta_description ||
                  "Kesaria textiles is one of the leading manufacturer, exporter, wholesalers and dealers of high quality & best rated textile company in Surat."
                  : seoData?.meta_description ||
                  "Kesaria textiles is one of the leading manufacturer, exporter, wholesalers and dealers of high quality & best rated textile company in Surat."
              }
            />
            <meta
              property="og:url"
              content={`${window.location.hostname == "localhost" ? "http" : "https"
                }://${window.location.host}/blog/`}
            />
            <meta
              property="article:published_time"
              content="2016-07-18T03:29:30+00:00"
            />
            <meta
              property="article:modified_time"
              content="2024-05-22T08:21:32+00:00"
            />
            <meta name="twitter:card" content="summary" />
            <meta
              name="twitter:title"
              content={
                categoryname
                  ? cateMetaData?.meta_title ||
                  "Blog Category | Kesaria Textile Company ~ Top Textile Company In Surat"
                  : seoData?.meta_title ||
                  "Blog Page | Kesaria Textile Company ~ Top Textile Company In Surat"
              }
            />
            <meta
              name="twitter:description"
              content={
                categoryname
                  ? cateMetaData?.meta_description ||
                  "Kesaria textiles is one of the leading manufacturer, exporter, wholesalers and dealers of high quality & best rated textile company in Surat."
                  : seoData?.meta_description ||
                  "Kesaria textiles is one of the leading manufacturer, exporter, wholesalers and dealers of high quality & best rated textile company in Surat."
              }
            />

            <script type="application/ld+json">
              {JSON.stringify(jsonLdData)}
            </script>
          </Helmet>

          <BlogList
            blogpageData={Bloglist}
            currentPage={currentPage}
            totalPages={totalPages}
            handlePageChange={handlePageChange}
            setmaxrecord={setmaxrecord}
            maxrecord={maxrecord}
          />
          <BlogZeroHero counter={counter} />
          <Blogslider data={BlogSlider} />
          <BlogOwnStorySec />
          <Blogretailreview reviewdata={Blogreview} />
          <ManufacturerCard />
          <div className="mb-3 mb-md-0"></div>
        </div>
      )}
    </>
  );
};
